import { RootState } from 'theSource/app/store';

export const selectFeedMessageCount = (state: RootState) =>
  state.theSource.feedMessages.count;

export const selectViewedIDs = (state: RootState) =>
  state.theSource.feedMessages.viewedIDs;
